import { AffiliateProgramFeatureUtils } from '@okletsplay/core';
import config from 'config/config';

export const AffiliateProgramConfig = new AffiliateProgramFeatureUtils(
  config.affiliateProgramFeatures ?? ''
);
